import classNames from 'classnames';
import type { ReactNode } from 'react';
import styled from 'styled-components';

import { FullViewportScroll } from '#src/atoms/container/FullViewportScroll/index.tsx';
import { Vertical } from '#src/atoms/layout/flex/index.tsx';
import { BodyS, HeadlineL, LabelS } from '#src/atoms/typography/index.tsx';
import type { Color } from '#src/style/types.ts';

const Scrollable = styled(FullViewportScroll)`
  align-items: start;
  gap: var(--triple-unit);
  white-space: nowrap;
  overflow-y: hidden;
  scroll-behavior: smooth;
  > * {
    flex-basis: 120px;
    scroll-snap-align: start;
    width: max-content;
  }

  &.fullWidth > * {
    flex: 1;
  }
`;

const Body = styled(HeadlineL).attrs({ as: 'div' })`
  height: var(--quadruple-unit);
`;

export type MetricProps = {
  label: ReactNode;
  body: ReactNode;
  color?: Color;
  subLabel?: ReactNode;
};

type Props = {
  metrics?: MetricProps[];
  fullWidth?: boolean;
};

const Metric = ({ label, color, body, subLabel }: MetricProps) => {
  return (
    <Vertical gap={0.5}>
      <LabelS as="p" color="var(--c-nd-600)">
        {label}
      </LabelS>
      <Body color={color}>{body}</Body>
      {subLabel !== undefined && (
        <BodyS as="p" color="var(--c-nd-600)">
          {subLabel}
        </BodyS>
      )}
    </Vertical>
  );
};

export const HeaderMetrics = ({ metrics, fullWidth }: Props) => {
  if (!metrics?.length) return null;
  return (
    <Scrollable className={classNames({ fullWidth })}>
      {metrics.map((metric, index) => (
        // oxlint-disable-next-line react/no-array-index-key
        <Metric key={index} {...metric} />
      ))}
    </Scrollable>
  );
};
